import { EyeFilled, SearchOutlined, UserOutlined } from '@ant-design/icons'
import { Avatar, Button, Descriptions, Input, message, Modal, Popconfirm, Select, Table, Tag, Tooltip } from 'antd'
import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { RiDeviceRecoverFill } from 'react-icons/ri'
import { SERVER_ADDRESS } from '../../Config/Config'
import { PiRecycleDuotone } from 'react-icons/pi'

const DeletedAccounts = () => {
    const [data,setData] = useState([])
    const [openModal,setOpenModal] = useState(false)
    const [currentRow,setCurrentRow] = useState(null);
    const [searchTerm,setSearchTerm] = useState('');
    const [filteredData,setFilteredData] = useState([]);
    const [gender,setGender] = useState(null)
    const userData = JSON.parse(atob(localStorage.getItem('token').split('.')[1]));
    const userPermission = userData.privelege || []

    const deletionTypeMap = {
        1: "Marriage Fixed",
        2: "Married",
        3: "Too Many Calls",
    };

    const fetchDeletedAccounts = async()=>{
        try {
            const response = await axios.get(`${SERVER_ADDRESS}/api/deletedUsers`);
            if(response.status === 200 && response.data.result === 1){
                setData(response.data.data)
                setFilteredData(response.data.data)
            }
        } catch (error) {
            message.error({content:"Oops Something went wrong !"})
        }
    }

    useEffect(()=>{
        applyFilter();
    },[searchTerm,gender])

    const recoverAccount = async(id)=>{
        try {
            const response = await axios.post(`${SERVER_ADDRESS}/api/recoverAccount`,{userId:id})
            if(response.status === 200 && response.data.result === 1){
                const updatedUser = filteredData.filter(user=>user.id !== id)
                setFilteredData(updatedUser)
            }
            if(response.status === 200 && response.data.result === 0){
                message.error({content:`${response.data.message}`})
            }
        } catch (error) {
            message.error({content:"Oops Something Went Wrong !"})
        }
    }

    const applyFilter = ()=>{
        let filtered = data;
        if(!searchTerm){
            setFilteredData(data)
        }
        else if(searchTerm) {
            filtered = filtered.filter((user)=>(
                user.name.toLowerCase().includes(searchTerm.toLowerCase())
            ))
        }
        if (gender !== null) {
            filtered = filtered.filter((user) => user.gender == gender);
        }
        setFilteredData(filtered)
    }

    const genderOption =[
        {
            label:"Groom",
            value:'1'
        },
        {
            label:"Bride",
            value:"2"
        }
    ]

    const handleModalClose = ()=>{
        setOpenModal(false);
        setCurrentRow(null)
    }

    const handleView = (record)=>{
        setCurrentRow(record)
        setOpenModal(true)
    }

    useEffect(()=>{
        fetchDeletedAccounts();
    },[])

    const columns = [
        {
            title:"Id",
            dataIndex:"id",
            key:"id"
        },
        {
            title:"Avatar",
            key:"profile",
            render:(_,record)=>{
                return (
                    record.photo.length > 0 ? <Avatar src={record.photo[0]} size={64} /> : <Avatar icon={<UserOutlined />} size={64} />
                )
            }
        },
        {
            title:"Name",
            dataIndex:"name",
            key:"name"
        },
        {
            title:"Gender",
            key:"gender",
            render:(_,record)=>{
                return (
                    record.gender === '1' ? <Tag color='blue' >Groom</Tag> : <Tag color='magenta'>Bride</Tag>
                )
            }
        },
        {
            title:"Email",
            dataIndex:"email",
            key:"email"
        },
        {
            title:"Phone",
            dataIndex:"phone",
            key:"phone"
        },
        {
            title:"Options",
            key:"options",
            render:(_,record)=>(
                <div className='d-flex flex-row gap-2' >
                    <Tooltip title='View Deletion Details' >
                        <Button onClick={()=>handleView(record)} variant='filled' color='cyan' >
                            <EyeFilled />
                        </Button>
                    </Tooltip>
                    {userPermission.includes("delete") && (
                    <Tooltip title='Active Account' >
                        <Popconfirm placement='left' title='Are You sure want to active this account ?' onConfirm={()=>recoverAccount(record.id)} >
                            <Button variant='filled' color='blue' >
                                <PiRecycleDuotone />
                            </Button>
                        </Popconfirm>
                    </Tooltip>
                    ) }
                </div>
            )
        }
        
    ]

  return (
    <div style={{marginTop:"4rem"}} >
        <div className='d-flex flex-row gap-4 mb-3' >
            <Input style={{width:'14rem'}} onChange={(e)=>setSearchTerm(e.target.value)} placeholder='Search By Name' prefix={<SearchOutlined />} />
            <Select style={{width:'14rem'}} onChange={(e)=>setGender(e)} options={genderOption} placeholder='Select by Gender' />
        </div>
        <Table columns={columns} dataSource={filteredData} rowKey={'id'} />
        <Modal title='Deletion Information' width="60%" open={openModal} footer={false} maskClosable={true} onCancel={()=>{handleModalClose()}} >
            <div>
                <p>Deletion Type : <span>{deletionTypeMap[currentRow?.type] || "Others"}</span> </p> 
                <p>Deletion Description : <span>{currentRow?.description}</span> </p>
                <p>Deletion Date : <span>{new Date(new Date(currentRow?.deleted_at).getTime() - 15 * 24 * 60 * 60 * 1000).toString()}</span> </p>
            </div>
        </Modal>
    </div>
  )
}

export default DeletedAccounts